import { Component, OnInit } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';

import { RouterFacade } from '@cigna/core/router-state';
import { ShellFacade } from '@cigna/chcp/shell/data-access';

import keys from 'lodash/keys';
import {
  COOKIE_EXCEPTION_LIST,
  DEEPLINK_BLACKLIST,
} from '@cigna/chcp/shared/util';

@Component({
  selector: 'cigna-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent implements OnInit {
  queryParams$ = this.routerFacade.queryParams$;

  constructor(
    private routerFacade: RouterFacade,
    private shellFacade: ShellFacade,
    private cookieService: CookieService,
  ) {}

  loginAlert$ = this.shellFacade.alertPublic$;

  ngOnInit() {
    this.shellFacade.reset();
    this.shellFacade.loadPublicAlerts();
    this.clearCookies();
    sessionStorage.clear();
  }

  clearCookies() {
    const allCookies: string[] = keys(this.cookieService.getAll());
    const deeplinkCookie: string = this.cookieService.get('CHCP_DEEPLINK');

    allCookies.forEach((cookieName) => {
      if (
        !COOKIE_EXCEPTION_LIST.some((exception) => exception.test(cookieName))
      ) {
        this.cookieService.delete(cookieName, '/');
      }
    });

    if (
      deeplinkCookie &&
      DEEPLINK_BLACKLIST.some((cookie) => cookie === deeplinkCookie)
    ) {
      this.cookieService.delete('CHCP_DEEPLINK', '/');
    }

    // clear analytics login success variable
    localStorage.setItem('adobeLoginSuccess', 'n');
  }
}
